export default () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M20.3312 6.19534L15.6267 2.17513C15.199 1.91852 14.6858 1.91852 14.4292 2.3462L3.17107 16.256C3 16.427 3 16.6836 3 16.9403L3.34215 21.2171C3.42768 21.7303 3.85536 22.0724 4.36858 21.9869L8.6454 21.6448C8.90201 21.5592 9.07309 21.4737 9.24416 21.3026L20.4168 7.39285C20.7589 7.0507 20.6734 6.45195 20.3312 6.19534ZM17.7651 7.82053L14.3437 4.99783L15.199 4.05693L18.535 6.96516L17.7651 7.82053ZM13.3172 6.28087L16.6532 9.18911L8.13218 19.934L5.05287 20.1906L4.71073 17.1113L13.3172 6.28087Z"
      fill="currentColor"
    />
  </svg>
);
